import {Injectable} from "@angular/core";
import {catchError, Observable, throwError} from "rxjs";
import {UserDataApi} from "../api/user-data.api";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class UserDataService {
  private fetchUserDataUrl = environment.apiBaseUrl + '/internalApi/fetchUserData';

  constructor(private http: HttpClient) {}

  fetchUserData(): Observable<UserDataApi> {
    return this.http.get<UserDataApi>(this.fetchUserDataUrl, { withCredentials: true }).pipe(
      catchError((error) => {
        return throwError(error);
      })
    );
  }

}
